//enum Modules { GridPanels, ExportExcel }
ModuleType='GridPanels';
/*
  DO NOT remove this! Only do so if you plan to upgrade the versions of jquery ui or its related libraries
  Overriding the curCSS function, which is required since the version of jquery UI and the version of jquery aren't in sync
*/
jQuery.curCSS = function(element, prop, val) {
    return jQuery(element).css(prop, val);
};
var today = new Date();
currentTime = today.toUTCString();
currentURL = window.location.href
//Adding this as per CA-4261, since only in STD, the change event of all the sliders get called on Clear All
isClearAll = false;
hasRevBeenSaved = false;
sharable_rp_setting = localStorage.getItem("sharable_rightpanel_setting_list");
sharable_rightpanel_setting_list = sharable_rp_setting === null ? [] : JSON.parse(sharable_rp_setting);
function  display_trend_name(){
    var growthType = $.grep(window.MEData.panels, function(n){
        return (n.name == GROWTHTYPES)
    })[0];
    var trend_period = growthType.trendYear;
    if (trend_period !== null) {
        var split_trend_year = trend_period.split('-');
        var slice_index = -2;
        if (split_trend_year[1].indexOf('E') > -1){
            slice_index = -3;
        }
        display_trend_year = split_trend_year[0] + '-' + split_trend_year[1].slice(slice_index) + '=100%';
        return display_trend_year;
    }
}
GrowthTypesEnum = {
    "YoY%": "YoY Growth",
    "YoY#": "YoY Growth (#)",
    "Seq%": "Seq. Growth",
    "Seq#": "Seq. Growth (#)",
     "Trend": display_trend_name,
     "%": "As a % of"
}

window.rightPanelChanges = {
    'panels':[],
    'column_dimensions':[],
    'row_dimensions':[]
};

function showPanel(type) {
    var panelIndex = $('#mm').find('div[paneltype="' + type + '"]').show().index();
    var panels = $('#collapseOption').find('tr').eq(1).nextUntil($('#collapseOption').find('tr').last());
    panels.eq(2 * panelIndex).show();
    panels.eq((2 * panelIndex) + 1).show();
}

function hidePanel(type) {
    var panelIndex = $('#mm').find('div[paneltype="' + type + '"]').show().index();
    var panels = $('#collapseOption').find('tr').eq(1).nextUntil($('#collapseOption').find('tr').last());
    panels.eq(2 * panelIndex).hide();
    panels.eq((2 * panelIndex) + 1).hide();
    $('#mm').find('div[paneltype="' + type + '"]').hide();
}


function reloadPanels(gridMetaData, panelOpen, sectionName) {
    var lowerSectionName;
    var checkSection=(sectionName == undefined);
    if(!checkSection){
        lowerSectionName = sectionName.toLowerCase();
    }
    else{
        lowerSectionName = '';
    }

    Last_Used_Trend_Year = '';
    if (window.gSchedule && gridMetaData.panels.length == 0) {
        // hidePanel('source'); // TODO
        return;
    }

    //deep copy gridMetaData.panels to rightPanelChanges
    // window.rightPanelChanges.panels = jQuery.extend(true, [], gridMetaData.panels);
    // window.rightPanelChanges.column_dimensions = jQuery.extend(true, [], gridMetaData.column_dimensions);
    // window.rightPanelChanges.row_dimensions = jQuery.extend(true, [], gridMetaData.row_dimensions);
    window.MEData.panels = jQuery.extend(true, [], gridMetaData.panels);
    window.MEData.column_dimensions = jQuery.extend(true, [], gridMetaData.column_dimensions);
    window.MEData.row_dimensions = jQuery.extend(true, [], gridMetaData.row_dimensions);

    htmlInReloadPanels(checkSection,lowerSectionName, gridMetaData, sectionName, panelOpen);
}

function reload_title_panels(panels, sectionName) {
    var lowerSectionName;
    var variant_selected = '';
    var wTitle = '';
    var checkSection=(sectionName == undefined);
    if(!checkSection) {
        lowerSectionName = sectionName.toLowerCase();
    }
    else {
        lowerSectionName = '';
    }
    $.each(panels, function (indexpanels, valuepanels) {
        if (valuepanels.name.toLowerCase() == panelSections['periods'].secName.toLowerCase()) {
            wTitle = 'Select time periods to see forecasts on'
        }
        if (valuepanels.name.toLowerCase() == "display settings") {
            var title = '<b>'  + valuepanels.name + '</b><br>' + valuepanels.values[0].name + " : " + valuepanels.values[0].selected;
             $('#Img10.panel').closest('tr').attr('qttitle', title);
            qtipSettings($('#Img10.panel').closest('tr'), "qttitle", true);
            var ele = $('#mm').find('div[paneltype="displaysettings"]')
            ele.attr('qttitle', title);
            qtipSettings(ele, "qttitle", true);
        }
        if (valuepanels.name.toLowerCase() == panelSections['Analysis'].secName.toLowerCase()) {
            wTitle = 'Visualize revisions, distribution<br>and earnings surprises'
            var title = '<b>Visualizations (Labs)</b><br>';
            if (cva != "") {
                title += "Variation: enabled";
            }
            if (crdrevision != "") {
                title += "Revisions: Current vs " + crdrevision.substr(1) + " ago";
            }
            if (surprise != "") {
                title += "Surprise : enabled";
            }
            if (high || low || high_low_src != "") {
                title += "High / Low : enabled";
            }
            $('#Img11.panel').closest('tr').attr('qttitle', title);
        }
        if (valuepanels.name.toLowerCase() == panelSections['Sources'].secName.toLowerCase()) {
            wTitle = 'Customize consensus, broker views';
        }
        if (valuepanels.name.toLowerCase() == panelSections['Accounting basis'].secName.toLowerCase()) {
            wTitle = 'Switch between GAAP, operating and both accounting basis';
        }
        if (valuepanels.name.toLowerCase() == panelSections['Adjustments'].secName.toLowerCase() ) {
            wTitle = 'Choose whether you want to include Visible Alpha computed data in consensus'
        }

        if (valuepanels.name.toLowerCase() == panelSections['Revisions'].secName.toLowerCase()) {
            // TODO change here for revision
            wTitle = 'Look up estimates from specific<br>points in time in the past'
        }
        if (valuepanels.name.toLowerCase() == panelSections['GrowthTypes'].secName.toLowerCase()) {
            wTitle = 'See growth rates on a<br>sequential or periodic basis'
        }

        var popoverobj = {
            content: wTitle,
            width:250,
            style:"rightPanelTitles",
            placement: "auto-left",
            "closeable": false,
            cache:false,
            arrow:true,
            trigger:'hover'

        };
        var ele = $('#leftpanel').find('.panel-header.'+valuepanels.name);
        if(ele.length == 0){
            ele = $('#leftpanel').find('.panel-header[panelType="'+panelSections[valuepanels.name].secType + '"]');
        }
        $(ele).webuiPopover(popoverobj);
    });
}

callDefaultSetting = function (sectionName) {
    // var rightPanelScope = angular.element('#leftpanel').scope();
    // if(sectionName == 'All'){
    //     rightPanelScope.showClearAll = false;
    // }
    OnDefaultSetting(sectionName);
    window.MEData.user_dim_setting=gridLoadedMEData.user_dim_setting=false;
}


//on click of defaultsettings
function OnDefaultSetting(sectionName) {
    //$("#clear_all_block_ui").hide();
    localStorage.removeItem("sharable_rightpanel_setting_list");
    sharable_rightpanel_setting_list = []
   // $.blockUI.defaults.message = `<div class="loader_clear_all_box"><img class="loader_image_clear_all" src="${window.assetUrl}/spinner-blue.gif"/></div>`;
    abortAjaxCalls();
    var ObjW = new WebServiceCall();
    var csrftoken = getCookie('csrftoken');
    var ogData = GetTickerSourceData();
    $("#commonsizeToggleTable").find(".miniButtonsSelected").removeClass("miniButtonsSelected");
    $("#toggle-normal").find("div").addClass("miniButtonsSelected");
    currentClickedCommonSizeName = 'normal';
    dataInCommonsize = false;
    //show_block_ui = true;
    debouncedBlock(true)

    ObjW.DeletePanelSettings(ogData, csrftoken, sectionName);
    unClickInspectorTab();
}




//this function is called when click apply or cancel in right panel
function gridRefresh(img, event) {
    if (!event || (event && (!event.originalEvent && event.isTrigger))) {
        //interesting since it would come here only if it is triggered from the code and not the user
    }
    else{
        //switching the base to numbers, so that the right panle computations can run
        if($("#toggle-normal").length !== 0) {
            $("#commonsizeToggleTable").find(".miniButtonsSelected").removeClass("miniButtonsSelected");
            $("#toggle-normal").find("div").addClass("miniButtonsSelected");
            currentClickedCommonSizeName = 'normal';

            dataInCommonsize = false;
            dpValueChange(dataInCommonsize);
        }
    }
    MEData.initialCall = false;
    var sectionName = $(img).attr('id') !== undefined ? $(img).attr('id').split('-')[4] : undefined;
    //When the Save/Save n Select from the cc popup gets clicked, the id split returns undefined
    if(sectionName !== undefined){
        sectionName = sectionName.replace('_',' ');
    }
    else{
        sectionName = 'Sources';
    }
    //As per story CA-3852, adding a specific source condition to it
    if(sectionName == 'Sources'){
        window.gSource = gSourceFuture = gFocusSource;
    }
    else if(sectionName === 'Revisions'){
        hasRevBeenSaved = true;
    }

    analyticsProcessor(event);
    filteredSarData = null;
    if ($(img).attr('id') !== undefined && $(img).attr('id').indexOf('cancel') != -1) {
        var sectionDetailData = $.map(gridLoadedMEData.panels, function (obj, ind) {
            if (obj.name == sectionName) {
                var tempObj = {};
                tempObj["index"] = ind;
                tempObj["obj"] = obj;
                return tempObj;
            }
        });

        //window.MEData.panels[sectionDetailData[0].index] = sectionDetailData[0].obj;
        window.MEData.panels[sectionDetailData[0].index] = jQuery.extend(true, {}, sectionDetailData[0].obj);
        //window.MEData = jQuery.extend(true, {}, gridLoadedMEData);
        if ((cut == 'NMV' || cut == 'SCH') && sectionName === 'Analysis') {
            $("#variationSlider").slider("destroy");
            $('#revisionSlider').slider("destroy");
            $("#surpriseSlider").slider("destroy");
        }
        reloadPanels(window.MEData, true, sectionName);
        //changeInSections(sectionName);
        return ;
    }
    //set medata for specific panel on click of apply from rightpanelchanges
    // setMEDataOnApply(sectionName);
    if (custconCheck()) {
        var sourceDetailData = $.map(gridLoadedMEData.panels, function (obj, ind) {
            if (obj.name == 'Sources') {
                var tempObj = {};
                tempObj["index"] = ind;
                tempObj["obj"] = obj;
                return tempObj;
            }
        });
        window.MEData.panels[sourceDetailData[0].index] = jQuery.extend(true, {}, sourceDetailData[0].obj);
        window.MEData.panels[sourceDetailData[0].index] = jQuery.extend(true, {}, sourceDetailData[0].obj);
        //window.MEData = jQuery.extend(true, {}, gridLoadedMEData);
        reloadPanels(window.MEData, false, sectionName);
        alert('User included only non entitled source for custom consensus.');
        //changeInSections(sectionName);
        return;
    }
    debouncedBlock(true)
    setVisualizationOnApply();
    saveRightPanelSettings(sectionName);
    //Added ReloadPanels here as per story UIB-11, where removed revision dates were not getting removed from grid on apply
    //reloadPanels(window.MEData, true);
    rowclicked = false;
    explicitRefresh = false;
    var basisMEData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Accounting basis');
    });
    var basisGridMEData = $.grep(gridLoadedMEData.panels, function (n) {
        return (n.name == 'Accounting basis');
    });
    if (window.gVariant != "") {
        if (JSON.stringify(window.MEData.panels.getValues('name', 'Variants')) != JSON.stringify(gridLoadedMEData.panels.getValues('name', 'Variants'))) {
            window.gScenario = "";
            if (window.compositeEdit || editScenarioMode)
                window.location = window.projectArkUrl+'/mex/' + company +  '/' + cut + '/' + escape(pg) + "?variant=" + escape(window.gVariant);
            var objWebServiceCall = new WebServiceCall();
            objWebServiceCall.callGrid(false, window.MEData, true);
            return;
        }
    }
    if (JSON.stringify(basisMEData) == JSON.stringify(basisGridMEData)) {
        objME = new ModelExplorer();
        var revisionPanel = $.grep(window.MEData.panels, function (n) {
            if (n.name == "Revisions") {
                return n;
            }
        });
        if (revisionPanel && revisionPanel.length > 0) {
            // ToDO change here for revision
            // We need to reverse the revisions for row wise rendering. and change back to correct order for column wise.
            if (revisionPanel[0].type == "row") {
                var revisionObj = $.each(window.MEData.row_dimensions, function (indexRowData, valueRowData) {
                    if (valueRowData.name == 'Revisions') {
                        valueRowData.expansions = orderRevisions(valueRowData.expansions, true)
                    }
                });
            } else {
                var revisionObj = $.each(window.MEData.column_dimensions, function (indexRowData, valueRowData) {
                    if (valueRowData.name == 'Revisions') {
                        valueRowData.expansions = orderRevisions(valueRowData.expansions, false);
                    }
                });
            }
            revisionTypeChanged = true;
        }

        // if custom consensus is in focus then call the cache load first and then fire the pg requests.
        if (cut != 'SAR') {
            excl_sources = getExcludedBrokers();
            incl_sources = getIncludedBrokers();
        }
        if (cut == 'SCH') {
            if (isCustomInFocus()) {
                var objWebServiceCall = new WebServiceCall();
                objWebServiceCall.LoadScheduleCache();
            }
        }
        getChunkingPeriods();
        objME.LoadDataGrid(window.MEData, false);
        // if ($.inArray('source', rowDimension) > -1) {
        //     window.MEData.row_dimensions[$.inArray('source', rowDimension)].expansions = getSourceExpansion();
        // }
        if ($('.datagrid-footer').is(":visible") == false)
            setTimeout(reziseGridPanel, 100);
    }
    else {
        var objWebServiceCall = new WebServiceCall();
        objWebServiceCall.basisMetaData(false, null);
    }
    expandedRowList = [];
    var lowerName = sectionName.toLowerCase();
    var idText;
    var funcParam;
    lowerName = lowerName.replace(/\s/g,'');//For Accounting basis
    if(lowerName === 'growthtypes'){
        lowerName = "analytics(labs)";
        idText = "analyticslabs";
    }
    else if(lowerName === 'adjustments'){
        lowerName = "inferreddata";
        idText = lowerName;
    }
    else if(lowerName === 'revisions'){
        lowerName = "historicalestimates";
        idText = lowerName;
    }
    else{
        idText = lowerName;
    }

    funcParam = sectionName;
    if(lowerName !== 'analysis' && $("[id='clear_"+idText+"']").length ==0) {
        var funcName = " onclick='OnDefaultSetting("+ "\"" +funcParam+ "\"" + ")'";
        $("[id='mm"+lowerName+"PP']" +" .panel-tool").append('<a style="color:#1874AE;font-weight:400;" id="clear_' + idText + '"'+  funcName + '>Clear</a>');
        $("[id='mm"+lowerName+"PP']" +" .panel-tool").css({"width": "", "height": ""});
        $("[id='mm"+lowerName+"PP']" +" .panel-tool a:last").css({"margin-top": "5px"});
    }
    else if(lowerName === 'analysis'){
        var optName = "visualizations(labs)";
        if($("[id='clear_visualizationslabs']").length ==0) {
            var funcName = " onclick='OnDefaultSetting("+ "\"" +funcParam+ "\"" + ")'";
            $("[id='mm"+optName+"PP']" +" .panel-tool").append('<a style="color:#1874AE;font-weight:400;" id="clear_visualizationslabs"'+  funcName + '>Clear</a>');
            $("[id='mm"+optName+"PP']" +" .panel-tool").css({"width": "", "height": ""});
            $("[id='mm"+optName+"PP']" +" .panel-tool a:last").css({"margin-top": "5px"});
        }
    }

    displayInspectorInfo(window.MEData);
    window.MEData.user_dim_setting=gridLoadedMEData.user_dim_setting=true;
    unClickInspectorTab();
    //changeInSections(sectionName);
    //DefaultSettingEnable(true);

	// this is done to stop the panel from closing once it has been applied.
	if(event != null){
        // analyticsProcessor(event);
		event.stopPropagation();
	}
}

/**
 * remove class which identifies that this tab was active last time because on change in right panel
 * either some columns are added or removed, so inspector tab should reload next time, if same inspector tab
 * for same row is clicked. If we remove this then, on next click, system identifies that it is the same row
 * and same tab is being opened, so there is no need to fire api calls, so it shows up previously rendered
 * inspector tab which results in visually broken grid.
 */
function unClickInspectorTab() {
  var selectedInspectorTab = $('#footerTypeDiv .fstddivclick');
  if(selectedInspectorTab) {
    selectedInspectorTab.addClass('fstddiv')
    selectedInspectorTab.removeClass('fstddivclick');
  }
}
//analysis panel related functionality

function onAnalysis(obj, toDisable) {
     var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var analysisValues = defaultData[0].values;
    $.each(analysisValues, function (i, el) {
        if (el.name == 'Revisions') {
			if(toDisable) {
				el.selected = "";
                el.slider = $('#revisionSlider').slider('value');
                el.value = obj.value;
			}
			else {
				el.selected = obj.value;
                el.slider = $('#revisionSlider').slider('value');
                el.value = obj.value;
			}
        }
        else if (el.name == 'Show Variation') {
            el.selected = "";
            el.slider = $('#variationSlider').slider('value');
        } else if (el.name == 'High / Low') {
            el.selected = false;
        } else if (el.name == 'Surprise') {
            el.selected = '';
            el.slider = $('#surpriseSlider').slider('value');
        }
    });
}

function onVariation(toDisable) {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var analysisValues = defaultData[0].values;
    $.each(analysisValues, function (i, el) {
        if (el.name == 'Show Variation') {
			if(toDisable) {
				el.selected = "";
                el.slider = $('#variationSlider').slider('value');
			}
			else {
				el.selected = el.name;
                el.slider = $('#variationSlider').slider('value');
			}
        }
        else if (el.name == 'Revisions') {
            el.selected = "";
            el.slider = $('#revisionSlider').slider('value');
        } else if (el.name == 'High / Low') {
            el.selected = false;
        } else if (el.name == 'Surprise') {
            el.selected = '';
            el.slider = $('#surpriseSlider').slider('value');
        }
    });
}

function onSurprise(toDisable) {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var analysisValues = defaultData[0].values;
    $.each(analysisValues, function (i, el) {
        if (el.name == 'Surprise') {
			if(toDisable) {
				el.selected = '';
                el.slider = $('#surpriseSlider').slider('value');
			}
			else {
				el.selected = 'Surprise';
                el.slider = $('#surpriseSlider').slider('value');
			}
        }
        else if (el.name == 'Revisions') {
            el.selected = "";
            el.slider = $('#revisionSlider').slider('value');
        } else if (el.name == 'High / Low') {
            el.selected = false;
        } else if (el.name == 'Show Variation') {
            el.selected = "";
            el.slider = $('#variationSlider').slider('value');
        }
    });
}

function onHighLow(toDisable) {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var analysisValues = defaultData[0].values;
    $.each(analysisValues, function (i, el) {
        if (el.name == 'High / Low') {
			if(toDisable) {
				el.selected = false;
			}
			else {
				el.selected = true;
                $.each(el.values, function(ind, val){
                    if (val.name == 'High') {
                        if (val.selected) {
                            $('td[max]').addClass('high');
                        }
                    }
                    if (val.name == 'Low') {
                        if (val.selected) {
                            $('td[min]').addClass('low');
                        }
                    }
                });
			}
        }
        else if (el.name == 'Revisions') {
            el.selected = "";
            el.slider = $('#revisionSlider').slider('value');
        } else if (el.name == 'Show Variation') {
            el.selected = "";
            el.slider = $('#variationSlider').slider('value');
        } else if (el.name == 'Surprise') {
            el.selected = '';
            el.slider = $('#surpriseSlider').slider('value');
        }
    });
}
//todo check use of gridLoadedMEData
function highLowFilter(property, isChecked) {
    var id = property.toLowerCase();
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var highLowPanel = $.grep(defaultData[0].values, function (n) {
        return (n.name == 'High / Low');
    });
    var gridDefaultData = $.grep(gridLoadedMEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var gridHighLowPanel = $.grep(gridDefaultData[0].values, function (n) {
        return (n.name == 'High / Low');
    });
    $.each(highLowPanel[0].values, function(index, value) {
        if (value.name.toLowerCase() == id) {
            if (isChecked) {
                value.selected = true;
                if (value.name == 'High') {
                    high = true;
                    $('td[max]').addClass('high');
                }
                if (value.name == 'Low') {
                    low = true;
                    $('td[min]').addClass('low');
                }
                $('#lbl_' + id).removeClass('fa-square-o').addClass('fa-check-square');
            } else {
                value.selected = false;
                if (value.name == 'High') {
                    high = false;
                    $('td[max]').removeClass('high');
                }
                if (value.name == 'Low') {
                    low = false;
                    $('td[min]').removeClass('low');
                }
                $('#lbl_' + id).removeClass('fa-check-square').addClass('fa-square-o');
            }
        }
    });
    gridHighLowPanel[0].values = highLowPanel[0].values;
    saveRightPanelSettings('Analysis');
}

function highLowSourceFilter(ele) {
    var id = $(ele).attr('id');
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var highLowPanel = $.grep(defaultData[0].values, function (n) {
        return (n.name == 'High / Low');
    });
    if ($(ele).is(':checked')){
        if (id == 'all_src') {
            highLowPanel[0].high_low_src = 'all';
            $('#lbl_all_src').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
            $('#lbl_entitled_src').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
        } else {
            highLowPanel[0].high_low_src = 'entitled';
            $('#lbl_all_src').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
            $('#lbl_entitled_src').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
        }
    } else {
        if (id != 'all_src') {
            highLowPanel[0].high_low_src = 'all';
            $('#lbl_all_src').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
            $('#lbl_entitled_src').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
        } else {
            highLowPanel[0].high_low_src = 'entitled';
            $('#lbl_all_src').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
            $('#lbl_entitled_src').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
        }
    }
}
//period panel fucntionality begins
function FillYearMapping(result) {
    var defaultData = window.MEData.panels.filter( function (n) {
        return (n.name.toLowerCase() == "periods");
    })[0];
    defaultData.yearMapping = {};
    for(var i=0; i<result.length; i++){
        var value = result[i];
        //var value_text = getPeriodLabel(value);
        var year = value.match(/-(\d+)/)[0];
        year = Number(year.substr(1));

        defaultData.yearMapping[value] = year;
    };
}

function getPeriodLabel(period_str) {
    return period_str.substr(0, 7) + period_str.substr(9, 50)
}
//TO-DO - Keeping this since we need to disable the cancel and apply for sources
tempRepresentSourceCount = 0;
function RepresentSource(showIn, event) {
    var rowColDict = {
        'row': 'row_dimensions',
        'column': 'column_dimensions'
    }

    var objME = new ModelExplorer();
    var panelData = window.MEData.panels.filter( function (n) {
        return (n.name == "Sources");
    });
    analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS.SOURCE.DIMENSION, showIn);
    analyticsProcessor(event, showIn);

    if (showIn == panelData[0].type) {
        var rowOrColDimensionData = window.MEData[rowColDict[showIn]];

        for(var ind=0; ind<rowOrColDimensionData.length; ind++){
            var val = rowOrColDimensionData[ind];
            if (val.name == 'Sources') {
                rowOrColDimensionData.splice(ind, 1);
                break;
            }
        };
    }

    var coldimensionData = window.MEData.column_dimensions.filter( function (n) {
        return (n.name == "Sources");
    });
    var rowdimensionData = window.MEData.row_dimensions.filter( function (n) {
        return (n.name == "Sources");
    });

    panelData[0].type = showIn;

    if (coldimensionData.length == 0 && rowdimensionData.length == 0) {
        var defaultData = samplecolrow.panels.filter( function (n) {
            return (n.name == "Sources");
        });
        var object = {
            "values": [
                {
                    "expanded": false,
                    "name": window.gSource,
                    "validity": (sourcesExist) ? "future" : undefined
                }
            ],
            "expansions": [],
            "name": "Sources"
        }
        object.expansions = getSourceExpansions(defaultData[0]);
        if (showIn == "row") {
            object.expansions = object.expansions[0];
            window.MEData.row_dimensions.push(object);
        } else {
            if (sourcesExist) {
                object.values.push(object.values[0]);
                object.values[0] = {'expanded': false, 'name': gSourceActual, "validity": 'actual'};
            }
            window.MEData.column_dimensions.push(object);
        }
    }
    else {
        if (showIn == "row") {
            if (coldimensionData.length > 0) {
                window.MEData.column_dimensions.splice($.inArray("source", colDimension), 1);

                coldimensionData[0].values = coldimensionData[0].values.filter( function (index, value) {
                    if (index.name == gSourceFuture) return index;
                });

                if ($.inArray("source", defaultrowDimension) == -1) {
                    window.MEData.row_dimensions.push(coldimensionData[0]);
                } else {
                    window.MEData.row_dimensions.splice($.inArray("source", defaultrowDimension), 0, coldimensionData[0]);
                }
                gSourceActual = gSourceFuture;
            }
        } else {
            // gSourceActual = $('#focus_source_option_historical').val();
            //Little Bit Doubtful
            if ($.inArray("source", rowDimension) > -1) {
                window.MEData.row_dimensions.splice($.inArray("source", rowDimension), 1);
            }
            if (sourcesExist && rowdimensionData.length > 0) {
                rowdimensionData[0].values.push(rowdimensionData[0].values[0]);
                rowdimensionData[0].values[0] = {'expanded': false, 'name': gSourceActual, "validity": 'actual'};
            }

            if ($.inArray("source", defaultcolDimension) == -1) {
                window.MEData.column_dimensions.push(rowdimensionData[0]);
            } else {
                window.MEData.column_dimensions.splice($.inArray("source", defaultcolDimension), 0, rowdimensionData[0]);
            }
        }
    }

    if (inspectorType == "Sources") {
        rowclicked = false;
    }
    tempRepresentSourceCount++;
    order_dimensions(window.MEData);
    objME.LoadDataGrid(window.MEData, false);
    SetSourcePanelType(showIn);

    if ($('.datagrid-footer').is(":visible") == false) {
        setTimeout(reziseGridPanel, 100);
    }
}
function SetSourcePanelType(type) {
    if (type == 'column') {
        $('#column').removeClass('panel-btn-off').addClass('panel-btn-on');
        $('#row').removeClass('panel-btn-on').addClass('panel-btn-off');

    } else {
        $('#row').removeClass('panel-btn-off').addClass('panel-btn-on');
        $('#column').removeClass('panel-btn-on').addClass('panel-btn-off');
    }
}

//todo change this for expansions option
function getSourceExpansions(defaultData, isFooter) {
    var expansions = [];
    var newArray = [];
    var historicalsExpansion = [];

    for(var i=0; i<defaultData.values.length; i++){
        var defaultSources = defaultData.values[i];
        var tempArr = defaultSources.values.slice();
        if (tempArr.length > 0 && defaultSources.name != 'Brokers') {
            newArray = newArray.concat(tempArr);
        } else if (tempArr.length > 0 && defaultSources.name == 'Brokers') {
            newArray = newArray.concat(tempArr.reverse());
        }
    };
    if(isFooter){
        for(var index=0; index<newArray.length; index++){
            var value = newArray[index];
            if (value.selected == true && expansions.indexOf(value.name)==-1)
                expansions.push(value.name);
        };
        return [expansions.reverse()];
    }
    for(var index=0; index<newArray.length; index++){
        var value = newArray[index];
        if (value.selected == true && gSourceFuture != value.name && value.focus == false)
            expansions.push(value.name);
    };

    for(var index=0; index<newArray.length; index++){
        var value = newArray[index];
        if (defaultData.type == 'column' && value.selected && gSourceActual != value.name && !value.historical_focus) {
            historicalsExpansion.push(value.name);
        } else if (value.selected && gSourceFuture != value.name && defaultData.type == 'row' && !value.focus) {
            historicalsExpansion.push(value.name);
        }
    };

    /* for 'freemium_user' values list will be empty , so length of historicalsExpansion and expansions would be 0 */
    if (historicalsExpansion.length>0 || expansions.length>0) {
        return [historicalsExpansion.reverse(), expansions.reverse()]
    }else{
        return []
    }
}


function HistoricalsFilter(chkBox) {
    var extras = {};
    extras["UTCTIME"] = currentTime;
    extras["URL"] = currentURL;

    var lblid = '#lbl' + chkBox.id;
    if ($(chkBox).is(":checked")) {
        $(lblid).removeClass('fa-square-o').addClass('fa-check-square');
        extras["VALUE"] = 'ON';
    } else {
        $(lblid).removeClass('fa-check-square').addClass('fa-square-o');
        extras["VALUE"] = 'OFF';
    }
    if(window.MEData.view_code != 'SAR') {
        dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_SOURCES_' + chkBox.value.toUpperCase(), extras, '');
    } else {
        dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_SOURCES_' + chkBox.value.toUpperCase(), extras, window.gSource);
    }
    objME = new ModelExplorer();
    var defaultData = $.grep(window.MEData.panels, function (n) {
            return (n.name == "Sources");
    });

    if (defaultData.length > 0) {
        var defaultData = $.grep(defaultData[0].values, function (n) {
            return (n.name == "Historicals");
        });
    }
    sourceCheck();
    $.each(defaultData, function(i, v) {
        $.each(v.values, function (index, value) {
            var id = value.name.replace(/\s/g,'');
            value.selected = $("#" + id).is(':checked') == true ? true : false;
        });
    });
    objME.LoadDataGrid(window.MEData, false);
    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout(reziseGridPanel, 100);
}
function SourceFilter(chkBox, type) {
    var extras = {};
    extras["UTCTIME"] = currentTime;
    extras["URL"] = currentURL;

    var lblid = chkBox.value == "All" ? chkBox.id : chkBox.value;
    if (type == "Sources") {
        if (chkBox.value != "All") {
            if (!$(chkBox).is(":checked")) {
                $('#lbl' + lblid).removeClass('fa-check-square').addClass('fa-square-o');
                extras["VALUE"] = 'OFF';
                if ($.inArray(lblid, restrict_sources) == -1) {
                    $('#lbl' + lblid).closest('span').find('input[type="radio"]').attr('disabled', true);
                }
            } else {
                $('#lbl' + lblid).removeClass('fa-square-o').addClass('fa-check-square');
                extras["VALUE"] = 'ON';
                if ($.inArray(lblid, restrict_sources) == -1) {
                    $('#lbl' + lblid).closest('span').find('input[type="radio"]').attr('disabled', false);
                }
            }
        } else {
            if ($(chkBox).is(":checked")) {
                $('#lbl' + lblid).removeClass('fa-square-o').addClass('fa-check-square');
                extras["VALUE"] = 'ON';
            } else {
                $('#lbl' + lblid).removeClass('fa-check-square').addClass('fa-square-o');
                extras["VALUE"] = 'OFF';
            }
        }
        if(window.MEData.view_code != 'SAR') {
            dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_SOURCES_' + chkBox.value.toUpperCase(), extras, '');
        }
        else{
            dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_SOURCES_' + chkBox.value.toUpperCase(), extras, window.gSource);
        }
    } else {
        if ($('#lbl' + lblid)[0].style.backgroundImage != "") {
            if ($('#lbl' + lblid)[0].style.backgroundImage.indexOf('off.png') > 0) {
                $('#lbl' + lblid).attr("style", "background: url("+static_base_url+"images/on.png) left center no-repeat;margin-left:-15px;");
            } else {
                $('#lbl' + lblid).attr("style", "background: url("+static_base_url+"images/off.png) left center no-repeat;margin-left:-15px;");
            }
        }
    }
    type = type.split(':')[0];
    objME = new ModelExplorer();
    if (type == "Sources") {
        /*todo: enable it with filter funcitonality*/
        if (chkBox.type == "radio") {
            window.gSource = chkBox.value;
            $('#view').text('#' + cut + ' - ' + window.gSource);
        }
        var defaultData = $.grep(window.MEData.panels, function (n) {
            return (n.name == "Sources");
        });

        if (defaultData.length > 0) {
            var defaultData = $.grep(defaultData[0].values, function (n) {
                return (n.name == "Brokers");
            });
        }
    } else if (type == "tickers") {
        var defaultData = $.grep(window.MEData.panels, function (n) {
            return (n.name == "Company Comps");
        });

    } else if (type == "Revisions") {
        var defaultData = $.grep(window.MEData.panels, function (n) {
            return (n.name == "Revisions");
        });
    } else if (type == "Scenarios") {
        var defaultDataVaraints = $.grep(window.MEData.panels, function (n) {
            return (n.name == "Scenarios");
        });
        defaultData = $.grep(defaultDataVaraints[0].values, function (n) {
            return (n.variant == window.gVariant);
        });
    }
    if ($(chkBox).val() == "All") {
        if ($(chkBox).is(':checked') == true) {
            $.each(defaultData[0].values, function (index, value) {
                if ($('#' + value.name).is(':disabled') == false) {
                    if (value.name.toLowerCase() != 'filings') {
                        $('#' + value.name).attr('checked', true);
                    }
                    analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS[type.substr(0, type.length - 1).toUpperCase()].SELECT, value.name);
                    if (type == "Sources") {
                        if (value.name.toLowerCase() != 'filings') {
                            $('#lbl' + value.name).attr('class', 'fa fa-check-square');
                        }
                         //$('#lbl' + value.name).closest('span').find('input[type="radio"]').attr('disabled', false);
                    } else {
                        $('#lbl' + value.name).attr("style", "background: url("+static_base_url+"images/on.png) left center no-repeat;margin-left:-15px;");
                    }
                }
            });
            //            HideSources('show');
        } else {
            $.each(defaultData[0].values, function (index, value) {
                if ($('#' + value.name).is(':disabled') == false) {
                    if (value.name.toLowerCase() != 'filings') {
                        $('#' + value.name).attr('checked', false);
                    }
                    analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS[type.substr(0, type.length - 1).toUpperCase()].REMOVE, value.name);
                    if (type == "Sources") {
                        if (value.name.toLowerCase() != 'filings') {
                            $('#lbl' + value.name).attr('class', 'fa fa-square-o');
                        }
                         //$('#lbl' + value.name).closest('span').find('input[type="radio"]').attr('disabled', true);
                    } else {
                        $('#lbl' + value.name).attr("style", "background: url("+static_base_url+"images/off.png) left center no-repeat;margin-left:-15px;");
                    }
                }
            });
        }
    } else {
        if ($(chkBox).is(':checked'))
            analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS[type.substr(0, type.length - 1).toUpperCase()].SELECT, chkBox.value);
        else
            analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS[type.substr(0, type.length - 1).toUpperCase()].REMOVE, chkBox.value);
    }

    sourceCheck();
    $.each(defaultData, function(i, v) {
        $.each(v.values, function (index, value) {
            value.selected = $("#" + value.name.replace('*', index)).is(':checked') == true ? true : false;
        });
    });
    if (defaultData[0].type != 'off' && type == "Revisions") {
        // TODO change here for revision
        panelDim = (defaultData[0].type == 'row') ? window.MEData.row_dimensions : window.MEData.column_dimensions;
        $.each(panelDim, function (index, value) {
            if (value.name == "Revisions")
                panelDim[index] = RevisionDimension();
        });
        //panelDimension = RevisionDimension();
    }

    // if (type == "Sources") {
    //     RepresentSource(window.MEData.panels.getValues("name", "Sources")[0].type);
    // }
    // else
    //     GetExpansionsForAllPanels();
    objME.LoadDataGrid(window.MEData, false);
    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout(reziseGridPanel, 100);
}

function sourceCheck() {
    var chkLength = $('input[name="chkname"]:checkbox').length;
    var checkedLen = $('input[name="chkname"]:checkbox:checked').length;
    if (chkLength != 0) {
        if (chkLength == checkedLen) {
            $('#chksrcall').attr('checked', true);
            $('#lblchksrcall').removeClass('fa-sqaure-o').addClass('fa-check-square');
        } else {
            $('#chksrcall').attr('checked', false);
            $('#lblchksrcall').removeClass('fa-check-square').addClass('fa-square-o');
        }
    }
}

function custconSourceCheck() {
    var chkLength = $('input[name="cc"]:checkbox').length;
    var checkedLen = $('input[name="cc"]:checkbox:checked').length;
    if (chkLength != 0) {
        if (chkLength == checkedLen) {
            $('#cc_all').attr('checked', true);
            $('#lbl_cc_all').removeClass('fa-sqaure-o').addClass('fa-check-square');
        } else {
            $('#cc_all').attr('checked', false);
            $('#lbl_cc_all').removeClass('fa-check-square').addClass('fa-square-o');
        }
    }
}


function getSourceExpansion(isFooter){
    var panelData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Sources");
    })[0];
    var expansionList = getSourceExpansions(panelData, isFooter);
//send only historical array since this function is called for row dimensions
    return expansionList[0];
}

function isCustomInFocus() {

	var panelObj = $.grep(window.MEData.panels, function (n, i) {
        if (n.name == "Sources") return true;
    });
	var computedSources = $.grep(panelObj[0].values, function (n, i) {
        if (n.name == "computed") return true;
    });
    if (computedSources.length > 0){
        var customSource = $.grep(computedSources[0].values, function (n, i) {
            if (n.name == "Custom") return true;
        });
        if(customSource.length > 0 && customSource[0].selected == true) {
            return true;
        }
    }
	return false;
}

function getExcludedBrokers(){
    var excludedBrokers = [];
    var panelObj = $.grep(window.MEData.panels, function (n, i) {
        if (n.name == "Sources") return true;
    });
    if(panelObj[0]["custom_consensus_mode"]==="byBroker" && panelObj[0]["excl_reaffirm_broker_consensus"]){
        return panelObj[0].excluded_broker
    }
    var brokers = $.grep(panelObj[0].values, function (n, i) {
        if (n.name == "Brokers") return true;
    });
    if(brokers.length>0) {
        $.each(brokers[0].values, function (index, value) {
            if (!value.selected_cc && value.name != 'Filings') {
                excludedBrokers.push(value.sourceid);
            }
        });
    }
    if(!panelObj[0].selected_cc_not_entitled && panelObj[0].non_entitled){
        excludedBrokers = excludedBrokers.concat(panelObj[0].non_entitled)
    }
    if(!panelObj[0].selected_excl_cc_not_entitled && panelObj[0].excl_non_entitled){
        excludedBrokers = excludedBrokers.concat(panelObj[0].excl_non_entitled);
    }
    if(panelObj[0].global_level_excl_source) {
        excludedBrokers = excludedBrokers.concat(panelObj[0].global_level_excl_source)
    }
    return excludedBrokers;
}

function showCCicon(value){
    if (cut == 'NMV' || cut == 'SCH' || cut == "STD"){
        var panelObj = window.MEData.panels.filter( function (n, i) {
            if (n.name == "Sources") return true;
        })[0]
        var customObj = panelObj.values.filter( function (n, i) {
            if (n.name == "computed") return true;
        })[0].values.filter(function(data){
            return data.name === "Custom"
        })[0]

        if (customObj.selected == true) {
            var showCC = false;
            
            var brokers = panelObj.values.filter( function (n, i) {
                if (n.name == "Brokers") return true;
            });
            for(var ind=0; ind<brokers[0].values.length; ind++){
                var val = brokers[0].values[ind];
                if (val.name == value && val.selected_cc) {
                    showCC = true;
                }
            };
            return showCC;
        } else {
            return false;
        }
    } else {
        return false;
    }
}


function showCPlusIcon(source){
    if (source === 'Consensus+' && (cut == 'NMV' || cut == 'SCH')){
        return true;
    }
    return false;
}

function showExcludedIcon(value,year){
    var showExcluded = false;
    var flag = false;
    if (cut == 'NMV' || cut == 'SCH' || cut == "STD") {
        if(typeof(year) === 'undefined' || year === '' || source_participation_in_consensus[year.toLowerCase()] == undefined){
            var panelObj = window.MEData.panels.filter( function (n, i) {
                if (n.name == "Sources") return true;
            });
            var brokers = panelObj[0].values.filter( function (n, i) {
                if (n.name == "Brokers") return true;
            });

            /* in case of 'freemium_user' brokers.length will be 0 */

            if (brokers.length > 0) {
                for(var ind=0; ind<brokers[0].values.length; ind++){
                    var val = brokers[0].values[ind];
                    if (val.name == value && val.excluded) {
                        showExcluded = true;
                    }
                };
            }
        } else {
            if(value === 'Filings' || value === 'Consensus' || value === 'Custom' || value === 'Consensus+' || value.indexOf('<') !== -1)
                return false;
            all_sources = source_participation_in_consensus[year.toLowerCase()].available_sources;
            for(var ind=0; ind<all_sources.length; ind++){
                var val = all_sources[ind];
                if (val == value) {
                    flag = true;
                }
            };
            if(!flag) {
                showExcluded = true;
            }
        }
    }
    return showExcluded;
}

function showConPlusIcon(value){
    if(cut !== "SAR"){
        var showConPlus = false;
        var panelObj = window.MEData.panels.filter( function (n, i) {
            if (n.name == "Sources") return true;
        });
        var brokers = panelObj[0].values.filter( function (n, i) {
            if (n.name == "Brokers") return true;
        });
        for(var ind=0; ind<brokers[0].values.length; ind++){
            var val = brokers[0].values[ind];
            if (val.name == value && val.pvt_broker) {
                showConPlus = true;
            }
        };
        return showConPlus;
    }else{
        return false;
    }
}

function custconCheck(){
    var panelObj = window.MEData.panels.filter( function (n, i) {
        if (n.name == "Sources") return true;
    });
    var checkedChkBox = $('input[name="cc"]:checkbox:checked').length;
    if (panelObj.length > 0) {
        if ($('input[value="cc_entitled"]').is(':checked') && $('input[value="cc_exclentitled"]').is(':checked')){
            return false;
        } else if ((panelObj[0].non_entitled && panelObj[0].non_entitled.length == 1) && checkedChkBox == 1 && $('input[value="cc_entitled"]').is(':checked')) {
            return true;
        } else if ((panelObj[0].excl_non_entitled && panelObj[0].excl_non_entitled.length == 1) && checkedChkBox == 0 && $('input[value="cc_exclentitled"]').is(':checked')){
            return true;
        } else {
            return false;
        }
    }
    return false;
}

function getIncludedBrokers(){
    var includedBrokers = [];
    var panelObj = $.grep(window.MEData.panels, function (n, i) {
        if (n.name == "Sources") return true;
    });

    if(panelObj[0]["custom_consensus_mode"]==="byBroker" && panelObj[0]["excl_reaffirm_broker_consensus"] && panelObj[0]["exclude_reaffirm_sources"].length !== 0){
        return panelObj[0].exclude_reaffirm_sources
    }
    var brokers = $.grep(panelObj[0].values, function (n, i) {
        if (n.name == "Brokers") return true;
    });
    if(brokers.length>0) {
        $.each(brokers[0].values, function (index, value) {
            if (value.selected_cc && value.name != 'Filings') {
                includedBrokers.push(value.sourceid);
            }
        });
    }
    if(panelObj[0].selected_excl_cc_not_entitled && panelObj[0].excl_non_entitled){
        includedBrokers = includedBrokers.concat(panelObj[0].excl_non_entitled);
    }

    if(panelObj[0].selected_cc_not_entitled && panelObj[0].non_entitled){
        includedBrokers = includedBrokers.concat(panelObj[0].non_entitled);
    }
    return includedBrokers;
}




function checkUncheckAllBrokers(brokers,checkAll){
    for (i=0;i<brokers.length;i++){
        selectedVal = brokers[i]['selected'];
        brokers[i]['selected'] = true;
    }
}


function RepresentGrowthType() {
     var defaultData = window.MEData.panels.filter( function (n) {
        return (n.name == GROWTHTYPES);
    });

    var rowdimensionData = window.MEData.row_dimensions.filter( function (n) {
        return (n.name == GROWTHTYPES);
    });

    if (rowdimensionData.length > 0) {

        rowdimensionData[0].expansions = defaultData[0].values.slice();

        if($.inArray(TREND, rowdimensionData[0].expansions ) > -1) {
            rowdimensionData[0].trendYear = defaultData[0].trendYear;
         }
    }

    if (defaultData.length > 0) {
        if (defaultData[0].type.toLowerCase() == "off" && rowdimensionData.length > 0) {
            var growthTypeIndex = window.MEData.row_dimensions.map( function (obj, index) {
                if (obj.name === GROWTHTYPES) {
                    return index;
                }
            }).filter(function(val){
                return val != undefined
            });

            window.MEData.row_dimensions.splice(growthTypeIndex, 1)

        } else if (defaultData[0].type.toLowerCase() == "row" && defaultData[0].values.length > 0 && rowdimensionData.length == 0) {
            // var object = GrowthTypeDimension();
            // window.MEData.row_dimensions.push(object);
        }
    }
}

function RepresentRevision(showIn) {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Revisions");
    });
    if (defaultData[0].type == showIn) {
        alert(showIn + " action is already implemented on Revisions");
        return;
    }
    var coldimensionData = $.grep(window.MEData.column_dimensions, function (n) {
        return (n.name == "Revisions");
    });

    var rowdimensionData = $.grep(window.MEData.row_dimensions, function (n) {
        return (n.name == "Revisions");
    });
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Revisions");
    });
    defaultData[0].type = showIn;
    if (showIn == "off") {
        if (coldimensionData.length != 0) {
            window.MEData.column_dimensions.splice($.inArray("revision", colDimension), 1)

        } else if (rowdimensionData.length != 0) {
            window.MEData.row_dimensions.splice($.inArray("revision", rowDimension), 1)
        }
    } else {
        if (coldimensionData.length == 0 && rowdimensionData.length == 0) {
            var defaultData = $.grep(samplecolrow.panels, function (n) {
                return (n.name == "Revisions");
            });
            var object = RevisionDimension();
            if (showIn == "row") {
                window.MEData.row_dimensions.push(object);

            } else {
                window.MEData.column_dimensions.push(object);
            }
        }
        else {

            if (showIn == "row") {
                removeRevisionDimension(showIn);
                if ($.inArray("revision", defaultrowDimension) == -1) {
                    window.MEData.row_dimensions.push(coldimensionData[0]);
                } else {
                    window.MEData.row_dimensions.splice($.inArray("revision", defaultrowDimension), 0, coldimensionData[0]);
                }
            } else {
                removeRevisionDimension(showIn);
                if ($.inArray("revision", defaultcolDimension) == -1) {
                    window.MEData.column_dimensions.push(rowdimensionData[0]);
                } else {
                    window.MEData.column_dimensions.splice($.inArray("revision", defaultcolDimension), 0, rowdimensionData[0]);
                }
            }
        }
    }
    var objME = new ModelExplorer();
    objME.LoadDataGrid(window.MEData, false);
    if ($('.datagrid-footer').is(":visible") == false) {
        setTimeout(reziseGridPanel, 100);
    }
}

function rightPanelSettings(sectionName){
    var revision = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Revisions");
    });
    var adjustments = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Adjustments");
    });
    var accountingBasis = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Accounting basis");
    });
    var analysis = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Analysis");
    });
    var periodData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "periods");
    });
    var sourcePanel = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Sources");
    });

    var growthType = $.grep(window.MEData.panels, function(n){
        return (n.name == GROWTHTYPES)
    })

    var panelData = GetTickerSourceData();
    if (((!sectionName && sharable_rightpanel_setting_list.includes('Revisions')) || sectionName == 'Revisions') && revision.length > 0) {
        //change here for values
        // var expansions = [];
        // $.each($('#revision .relative-date'), function(index, text) {
        //     var value = $.trim($(text).text());
        //     if (value !== 'Unset') {
        //         expansions.push(value);
        //     }
        // });
        // var isChecked = $('#revision .preQ-checkbox')[0].checked;
        // if (isChecked) {
        //     expansions.push('PreQ');
        // }
        // updatePreQ(isChecked);
        panelData.jsonData['Revisions'] = {
            'type': revision[0].type,
            'values': revision[0].values,
            'revision_date_list':revision[0].revision_date_list,
            'changed_date':revision[0].changed_date
        }
        // $('#revisionsection .custom-toggle-tab').removeClass('custom-toggle-tab-selected');
        // $('#revisionsection .custom-toggle-tab[data-value=' + revision[0].type +']').addClass('custom-toggle-tab-selected');
    }
    if (((!sectionName && sharable_rightpanel_setting_list.includes('Adjustments')) || sectionName == 'Adjustments') && adjustments.length > 0) {
        var values = [window.gAdjust];
        panelData.jsonData["Adjustments"] = {
            'values': values
        }
    }
    if (((!sectionName && sharable_rightpanel_setting_list.includes('Accounting')) || sectionName == 'Accounting basis') && accountingBasis.length > 0) {
        panelData.jsonData["Accounting basis"] = {
            'selected': accountingBasis[0].selected
        }
    }
    if (((!sectionName && sharable_rightpanel_setting_list.includes('Accounting')) || sectionName == 'Analysis') && analysis.length > 0) {
        // $.each(analysis[0].values, function(index, value){
        //     if (value.name == 'Show Variation') {
        //         value.slider = $('#variationSlider').slider('value');
        //     }
        //     if (value.name == 'Revisions') {
        //         value.slider = $('#revisionSlider').slider('value');
        //     }
        //     if (value.name == 'Surprise') {
        //          value.slider = $('#surpriseSlider').slider('value');
        //     }
        // });
        panelData.jsonData["Analysis"] = analysis[0].values;
    }

    if (((!sectionName && sharable_rightpanel_setting_list.includes(GROWTHTYPES)) || sectionName == GROWTHTYPES) && growthType.length > 0) {
        panelData.jsonData[GROWTHTYPES] = {
            'values': growthType[0].values,
            'type': growthType[0].type,
            'trendYear' : growthType[0].trendYear,
            'expandedRows':  growthType[0].expandedRows
        }
    }

    if (((!sectionName && sharable_rightpanel_setting_list.includes('periods')) || sectionName == 'periods') && periodData.length > 0) {
        panelData.jsonData["periods"] = {
            'multi_period': periodData[0].multi_period,
            'first_estimated_year': periodData[0].first_estimated_year ? ((endsWith(periodData[0].first_estimated_year, 'E') ? periodData[0].first_estimated_year.slice(0, -1).substr(-4) : periodData[0].first_estimated_year.substr(-4))) : null,
            'selected_from': (endsWith(periodData[0].selected_from, 'E') ? periodData[0].selected_from.slice(0, -1).substr(-4) : periodData[0].selected_from.substr(-4)),
            'selected_to': (endsWith(periodData[0].selected_to, 'E') ? periodData[0].selected_to.slice(0, -1).substr(-4) : periodData[0].selected_to.substr(-4)),
            'period_type': periodData[0].period_type,
            'interim_type': periodData[0].interim_type
        };
    }
    if (((!sectionName && sharable_rightpanel_setting_list.includes('Sources')) || sectionName == 'Sources') && sourcePanel.length > 0) {
        var selectedSource = [], selectedCCSource = [], computedSources = [], focusSource = '', notselectedsource=[];
        var historical_selected_sources=[];
        $.each(sourcePanel[0].values, function(index, value) {
            if (value.name.toLowerCase() == "brokers") {
                $.each(value.values, function(ind, val) {
                    if (val.focus) {
                        focusSource = val.name;
                    }
                    if (val.selected) {
                        selectedSource.push(val.name);
                    }
                    else{
                        notselectedsource.push(val.name)
                    }
                    if (val.selected_cc) {
                        selectedCCSource.push(val.name);
                    }

                });
            }
            if (value.name.toLowerCase() == "computed") {
                $.each(value.values, function(ind, val) {
                    if (val.focus) {
                        focusSource = val.name;
                    }
                    if (val.selected) {
                        computedSources.push(val.name);
                    }
                });
            }
            if (value.name.toLowerCase() == "historicals") {
                $.each(value.values, function(ind, val) {

                    if (val.selected) {
                        historical_selected_sources.push(val.name);
                    }
                });
            }
        });
        panelData.jsonData["Sources"] = {
            'type': sourcePanel[0].type,
            'selected': selectedSource,
            'not_selected': notselectedsource,
            'historical_selected_sources':historical_selected_sources,
            'focus': window.gFocusSource,
            'historical_focus':window.gSourceActual,
            'show_only_current': sourcePanel[0].show_only_current,
            'sort_column': sourcePanel[0].sort_column,
            'sort_order': sourcePanel[0].sort_order,
            'computed_sources': computedSources,
            'show_all_brokers_check': sourcePanel[0].show_all_brokers_check
        };
        panelData.jsonData["Custom"] = {
            'selected_cc': sourcePanel[0].date_custom_consensus ? [] : selectedCCSource,
            'show_all_brokers_ckeck_cc': sourcePanel[0].show_all_brokers_ckeck_cc,
            'show_only_current_cc': sourcePanel[0].show_only_current_cc,
//            'show_excluded_cc': sourcePanel[0].show_excluded_cc,
            'excl_non_entitled_brokers' : sourcePanel[0].selected_excl_cc_not_entitled,
            'non_entitled_brokers': sourcePanel[0].selected_cc_not_entitled,
            'customDate':sourcePanel[0].customDate,
            'date_custom_consensus': sourcePanel[0].date_custom_consensus,
            'relative_days': sourcePanel[0].relative_days,
            'inc_non_current_brokers': sourcePanel[0].inc_non_current_brokers,
            'custom_consensus_mode' :  sourcePanel[0].custom_consensus_mode,
            'custom_consensus_date_type' :  sourcePanel[0].custom_consensus_date_type,
            'excl_reaffirm_broker_consensus' : sourcePanel[0].excl_reaffirm_broker_consensus === "" ? false : sourcePanel[0].excl_reaffirm_broker_consensus,
        };
    }
    return panelData;
}

function GetTickerSourceData(){
    var panelData = {
        "company": company,
        "cut": cut == 'SAR'? cut : null,
        "source": cut == 'SAR'? window.gSource : null,
        "jsonData": {}
    };
    return panelData
}

function saveRightPanelSettings(sectionName) {
    var ObjW = new WebServiceCall();
    var csrftoken = getCookie('csrftoken');
    !(sharable_rightpanel_setting_list.includes(sectionName)) ? sharable_rightpanel_setting_list.push(sectionName): '';
    localStorage.setItem("sharable_rightpanel_setting_list",JSON.stringify(sharable_rightpanel_setting_list));
//    debugger;
    var data = rightPanelSettings(sectionName);
    ObjW.storePanelSettings(JSON.stringify(data), csrftoken);
}

/*revision functions*/
var revisionPanelCount = 1;


function revisionsUpdate(revisionNo,textValue,shouldCheck, isCustomConsensusDate) {
    var MEDataRevisionPanel = $.grep(window.MEData.panels, function (n) {
        if (n.name == "Revisions") {
            return n;
        }
    })[0];
    var temp = MEDataRevisionPanel.values;
    if (MEDataRevisionPanel.values[revisionNo] === undefined) {
        MEDataRevisionPanel.values[revisionNo] = '';
        MEDataRevisionPanel.revision_date_list[revisionNo] = '';
    }

    if (datevalidations(temp,textValue,shouldCheck, revisionNo + 1, isCustomConsensusDate)) {
        return true;
    }
    //MEDataRevisionPanel.values[revisionNo] = '';
    if (textValue) {
        if(textValue === 'Unset'){
            textValue = '';
        }
        var hasPreq = false;
        if(MEDataRevisionPanel.values[revisionNo] == 'PreQ'){
             hasPreq = true;
        }
        MEDataRevisionPanel.values[revisionNo] = textValue;
        if(textValue === '') {
            MEDataRevisionPanel.revision_date_list[revisionNo] = '';
        }
        else{
            var rev_date;
            if(!isCustomConsensusDate) {
                rev_date = $("#revisions-display-" + parseInt(revisionNo + 1)).attr("setDate").split('-');
            }
            else{
                rev_date = $("#revisions-display-cc-" + parseInt(revisionNo + 1)).attr("setDate").split('-');
            }
            MEDataRevisionPanel.revision_date_list[revisionNo] = $.datepicker.formatDate("mm-dd-yy", new Date(rev_date[2],rev_date[1] - 1,rev_date[0]));
            if(MEDataRevisionPanel.values.length === 1 && (!MEDataRevisionPanel.type || MEDataRevisionPanel.type == 'off')){
                $('#rowrevision').trigger('click');
            }

            if(isCustomConsensusDate) {
                var todayObject = new Date();
                var tillWhichDayObject = new Date(MEDataRevisionPanel.revision_date_list[revisionNo]);
                var dateDiff = countdown(todayObject, tillWhichDayObject, countdown.DAYS),
                //Subtracting 1 day since the diff includes a day here
                noOfDays = dateDiff.days - 1;
                // commenting as not required this method now
                // angular.element('[ng-controller=MexController]').scope().$apply(function ($scope) {
                //     $scope.numberOfDaysChange(noOfDays, tillWhichDayObject);
                // })
            }

        }
        if(hasPreq){
          MEDataRevisionPanel.values.push('PreQ');
          MEDataRevisionPanel.revision_date_list.push('PreQ');
        }
        MEDataRevisionPanel.changed_date = $.datepicker.formatDate("mm-dd-yy", new Date());
    }
    //if (MEDataRevisionPanel.type != 'off') {
    //    // TODO change here for revision
    //    panelDim = (MEDataRevisionPanel.type == 'row') ? window.MEData.row_dimensions : window.MEData.column_dimensions;
    //    $.each(panelDim, function (index, value) {
    //        if (value.name == "Revisions")
    //            panelDim[index] = RevisionDimension();
    //    });
    //}
    if (shouldCheck) {
        var extras = {};
        extras["REVISION_ORDER"] = revisionNo;
        extras["REVISION_VALUE"] = textValue;
        extras["UTCTIME"] = currentTime;
        extras["URL"] = currentURL;
        if(window.MEData.view_code != 'SAR') {
            dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_REVISION_DATE', extras, '');
        }
        else{
            dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_REVISION_DATE', extras, window.gSource);
        }
    }
    return false;
}



function datevalidations(lstRevision,currValue,shouldCheck, revisionNo, isCustomConsensusDate){
    var panel;
    var repeatedDatePanel;
    if( ModuleType=='GridPanels'){
        if(!isCustomConsensusDate) {
            panel = $('#revision [data-revision-panel-count=' + revisionNo + ']');
        }
        else{
            panel = $('#edit_cc_screen  [data-revision-panel-count=' + revisionNo + ']');
        }
    } else {
        panel = $('.revisions-options [data-revision-panel-count=' + revisionNo + ']')
    }
    if (shouldCheck && currValue === '0D' && ModuleType=='GridPanels') {
        setErrorForRevision(panel,'Only previous dates can be defined');
        return true
    }
    var revisionIndex = lstRevision.indexOf(currValue);
    if (shouldCheck && revisionIndex != -1 && revisionIndex != (revisionNo - 1)) {
        panel.find('.error-text').addClass('repeated-date').attr('check-date', currValue);
        setErrorForRevision(panel,'You have already selected this date. Each revision must be unique');
        //alert('This date is already present');
        return true;
    }
    panel.find('.revision-date').removeClass('revision-date-error');
    panel.find('.revision-icon-error').hide();
    panel.find('.error-text').removeClass('repeated-date').hide();
    panel.find('.header-text').show();
    return false
}


function appendDatePickerPanel() {
    if (revisionPanelCount >= 5) {
        return false;
    } else {
        revisionPanelCount++;
    }
    if (revisionPanelCount === 5) {
        $('#revision .max-revisions-alert').show();
        $('#revision .add-date-picker-button').hide();
    }
    var panel = '<div class="revisions-date-panel" data-revision-panel-count=' + revisionPanelCount +
        '><input type="text" placeholder="yyyy-mm-dd" id="revisions-display-' + revisionPanelCount +
        '" class="revision-date"><input type="text" id="revisions-picker-' + revisionPanelCount +
        '" class="date-picker-btn"><span class="fa fa-exclamation revision-icon-error" style="display:none"></span>'+
        '<span class="revision-image-bg"></span><div class="remove-date-picker-button fa fa-times"></div>'+
        '<div class="default-date-value-status"><span class="header-text" style="display:none;">Relative date: <span class="relative-date"></span>'+
        '</span><span class="error-text" style="display: none;">Format date as yyyy-mm-dd</span></div></div>';
    $('#revision .revisions-panel-container').append(panel);
    bindDatepickerEvents($("#revisions-picker-" + revisionPanelCount), $("#revisions-display-" + revisionPanelCount));
    $("#revision .revisions-date-panel[data-revision-panel-count=" + revisionPanelCount + "]").find('.remove-date-picker-button')
        .on('click', removeDatePickerPanel);
    //excelToExportData["Revisions"].values.push('0D');
    return $("#revision .revisions-date-panel[data-revision-panel-count=" + revisionPanelCount + "]");
}

function removeDatePickerPanel(event) {
    $('#revision .max-revisions-alert').hide();
    $('#revision .add-date-picker-button').show();
   
    var target = $(event.target).parents('.revisions-date-panel');
    panelCounter = Number(target.attr('data-revision-panel-count'));
    target.find('.date-picker-btn').datepicker('destroy');
    target.remove();


    var MEDataRevisionPanel = $.grep(window.MEData.panels, function (n) {
             if(n.name == "Revisions") {
                return n;
             }
        })[0];
    //Added for user-logging
    var extras = {};
    extras["REVISION_ORDER"] = panelCounter - 1;
    extras["REVISION_VALUE"] = MEDataRevisionPanel.values[panelCounter - 1];
    extras["UTCTIME"] = currentTime;
    extras["URL"] = currentURL;
    if(window.MEData.view_code != 'SAR') {
        dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_REVISION_DATE_REMOVE', extras, '');
    }
    else{
        dummyAjaxRequest(window.MEData.ticker, window.MEData.view_code, 'OPTIONS_REVISION_DATE_REMOVE', extras, window.gSource);
    }
    MEDataRevisionPanel.values.splice(panelCounter - 1, 1);
    MEDataRevisionPanel.revision_date_list.splice(panelCounter - 1, 1);

    panelCounter++;
    //excelToExportData["Revisions"].values.splice(panelCounter - 1, 1);
    for (var index=panelCounter; index <= revisionPanelCount; index++) {
        var $panel = $('#revision .revisions-date-panel[data-revision-panel-count=' + index + ']');
        var newIndex = index - 1;
        $panel.attr('data-revision-panel-count', newIndex);
        $panel.find('.date-picker-btn').attr('id', 'revisions-picker-' + newIndex).datepicker('destroy');
        $panel.find('.revision-date').attr('id', 'revisions-display-' + newIndex);
        bindDatepickerEvents($("#revisions-picker-" + newIndex), $("#revisions-display-" + newIndex));

        var superRevObject = {};
        superRevObject["values"] = MEDataRevisionPanel.values[newIndex - 1];
        superRevObject["revision_date_list"] = MEDataRevisionPanel.revision_date_list[newIndex - 1];
        superRevObject["changed_date"] = MEDataRevisionPanel.changed_date;
        superRevObject["isModified"] = MEDataRevisionPanel.isModified;

        if (MEDataRevisionPanel.values[newIndex-1] && MEDataRevisionPanel.values[newIndex-1] != '') {
            setRevisionDate($panel, superRevObject);
        }
    }
    revisionPanelCount--;
}


function bindRevisionData(revisionData) {
    bindDatepickerEvents($("#revisions-picker-1"), $("#revisions-display-1"));
    $('#revision .revisions-panel-container').empty();
    $('#revision .max-revisions-alert').hide();
    $('#revision .add-date-picker-button').show();
    revisionPanelCount = 1;
    var revisionValues = revisionData.values;
    var revisionArray = [];

    //set data for inactive companies
    if(revisionData.inactive_comp_latest_date && revisionData.type == 'off' && revisionValues.length == 0){
        RepresentRevision('column');
        revisionData.revision_date_list = [revisionData.inactive_comp_latest_date];
        //calculate days to set in values;
         var unchangedRevDate = new Date(revisionData.inactive_comp_latest_date);
        revisionDateInMilli = unchangedRevDate.getTime();
        var revisionDate = $.datepicker.formatDate("dd-M-yy", new Date(revisionDateInMilli));
        var superRevObject = {};
        superRevObject["values"] = revisionDate;
        superRevObject["revision_date_list"] = revisionDate;
        superRevObject["changed_date"] = revisionData.changed_date;
        revisionArray.push(superRevObject);
        setRevisionDate($("#revision .revisions-date-panel[data-revision-panel-count=1]"), revisionArray[0], true);


        $('#options-refresh-buttons-apply-Revisions').trigger('click');
        return;
    }

    for(var i = 0; i < revisionValues.length; i++){
        var superRevObject = {};
        superRevObject["values"] = revisionValues[i];
        superRevObject["revision_date_list"] = revisionData.revision_date_list[i];
        superRevObject["changed_date"] = revisionData.changed_date;
        revisionArray.push(superRevObject);
    }



    $('#revisionsection .custom-toggle-tab').removeClass('custom-toggle-tab-selected');
    $('#revisionsection .custom-toggle-tab[data-value=' + revisionData.type +']').addClass('custom-toggle-tab-selected');
    if (revisionValues.length < 1) {
        setRevisionDate($("#revision .revisions-date-panel[data-revision-panel-count=1]"), 'OD');
        $('#revision .preQ-checkbox').removeAttr('checked','checked');
        return;
    }
    
    //use updated object to populate
    if (revisionData.type !== 'off') {
        if (revisionValues[0] !== 'PreQ') {
            setRevisionDate($("#revision .revisions-date-panel[data-revision-panel-count=1]"), revisionArray[0]);
        } else {
            $('#revision .preQ-checkbox').attr('checked','checked');
        }
        for (var i = 1; i < revisionArray.length; i++) {
            if (revisionArray[i].values !== 'PreQ') {
                if (revisionPanelCount > 5) {
                    return;
                }
                var $revisionPanel = appendDatePickerPanel();
                if ($revisionPanel) {
                    setRevisionDate($revisionPanel, revisionArray[i]);
                }
            } else {
                $('#revision .preQ-checkbox').attr('checked','checked');
            }
        }
    } else {
        revisionData.values = [""];
        revisionData.revision_date_list = [""];

        $("#revision .revisions-date-panel[data-revision-panel-count=1]").find('.relative-date').text('Unset');
        setRevisionDate($("#revision .revisions-date-panel[data-revision-panel-count=1]"), 'OD');
        $("#revision #revisions-display-1").val('');
        $('#revision .preQ-checkbox').removeAttr('checked','checked');
    }
}

function updatePreQ(isChecked, shouldCallMetaCheck, event) {
    var extras = {};
    extras["UTCTIME"] = currentTime;
    extras["URL"] = currentURL;
    if(shouldCallMetaCheck) {
        var MEDataRevisionPanel = $.grep(window.MEData.panels, function (n) {
            if (n.name == "Revisions") {
                return n;
            }
        })[0];
    } else {
        var MEDataRevisionPanel = $.grep(window.MEData.panels, function (n) {
            if (n.name == "Revisions") {
                return n;
            }
        })[0];
    }
    var index = MEDataRevisionPanel.values.indexOf('PreQ');

   if(isChecked){
       if((!MEDataRevisionPanel.type || MEDataRevisionPanel.type == 'off') && event) {
            $('#rowrevision').trigger('click');
       }
    //push preQ in rightpanel settings value
        if (index === -1) {
            if(MEDataRevisionPanel.values[0] === ""){
                MEDataRevisionPanel.values[0] = 'PreQ';
                MEDataRevisionPanel.revision_date_list[0] = 'PreQ';
            }
            else{
                MEDataRevisionPanel.values[revisionPanelCount] = 'PreQ';
                MEDataRevisionPanel.revision_date_list[revisionPanelCount] = 'PreQ';
            }
        }
       extras["REVISION_VALUE"] = 'ON';
   } else {
    //remove preQ from rightpanel settings
        if (index != -1) {
            MEDataRevisionPanel.values.splice(index, 1);
            MEDataRevisionPanel.revision_date_list.splice(index, 1);
        }
       extras["REVISION_VALUE"] = 'OFF';
   }
    MEDataRevisionPanel.changed_date = $.datepicker.formatDate("mm-dd-yy", new Date());
    if (window.MEData.view_code != 'SAR') {
        callDummyAjaxRequest(event, window.MEData.ticker, window.MEData.view_code, 'OPTIONS_REVISION_PREQ', extras, '');
    } else {
        callDummyAjaxRequest(event, window.MEData.ticker, window.MEData.view_code, 'OPTIONS_REVISION_PREQ', extras, gSource);
    }
}


function saveSliderValueInGridMEdata(analysisPanel) {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var panelData = $.grep(defaultData[0].values, function (n) {
        return (n.name == analysisPanel);
    });
    var gridDefaultData = $.grep(gridLoadedMEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    var gridPanelData = $.grep(gridDefaultData[0].values, function (n) {
        return (n.name == analysisPanel);
    });

    if (panelData.length > 0) {
        gridPanelData[0].slider = panelData[0].slider;
    }
}

$(document).ready(function () {
    var splitUrl = window.location.pathname.split("/");
    if(splitUrl[1].toLowerCase() === "mex"){
        intialRevisionSetup();
        function sendInactive() {
            analyticsProcessor(undefined, 'USER_INACTIVE');
        }
        resetTimer = function() {
            if(typeof(inactiveTime) !== 'undefined') {
                clearTimeout(inactiveTime);
            }
            inactiveTime = setTimeout(sendInactive, 1800000); //30 mins here = 30 * 60 * 1000
        }
        //If user is idle for more than 30 minutes we need to send request to server to maintain the analytics log.
        logIdleUserData = function() {
            window.onload = resetTimer;
            document.onmousemove = resetTimer;
            document.onkeypress = resetTimer;
        };

        logIdleUserData();

        //Added trigger for inactive user logging
        document.onmousedown = function() {
            resetTimer();
        };
        
        //Added trigger for inactive user logging
        document.onkeypress = function() {
            resetTimer();
        };
    }
});



function intialRevisionSetup() {
    $('#revision .add-date-picker-button').on('click', function (event) {
        appendDatePickerPanel();
    })

    $('#revision .remove-date-picker-button').on('click', removeDatePickerPanel);
    var todayIs = new Date()
    var today = $.datepicker.formatDate("dd-mm-yy", new Date(todayIs.getTime()));
    $('#revisions-display-1').val('').attr('setDate', today);
    $('#revision .default-date-value-status .relative-date').text(today);
}

function getUnentitledSourceInfo() {
    var extraObj = {};
    if (cut == 'SCH' || cut == 'NMV' || cut == 'STD') {
        var panelObj = $.grep(window.MEData.panels, function (n, i) {
            if (n.name == "Sources") return true;
        });
        extraObj['selected_cc_not_entitled'] = panelObj[0].selected_cc_not_entitled != undefined ? panelObj[0].selected_cc_not_entitled : false;
        extraObj['selected_excl_cc_not_entitled'] = panelObj[0].selected_excl_cc_not_entitled != undefined ? panelObj[0].selected_excl_cc_not_entitled : false;
        extraObj['excl_non_entitled'] = panelObj[0].excl_non_entitled != undefined ? panelObj[0].excl_non_entitled : [];
        extraObj['non_entitled'] = panelObj[0].non_entitled != undefined ? panelObj[0].non_entitled : [];
    }
    return extraObj;
}


function setVisualizationOnApply() {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == 'Analysis');
    });
    if (defaultData && defaultData.length == 0) {
        return
    }
    var analysisValues = defaultData[0].values;
    $.each(analysisValues, function(index, value) {
        if (value.name == 'Show Variation') {
            if (value.selected) {
                cva = value.name;
            } else {
                cva = "";
            }
        } else if (value.name == 'Revisions') {
            if (value.selected) {
                crdrevision = value.value;
            } else {
                crdrevision = "";
            }
        }else if (value.name == 'Surprise') {
            if (value.selected) {
                surprise = value.name;
            } else {
                surprise = "";
            }
        }else if (value.name == 'High / Low') {
            if (value.selected){
                high_low_src = value.high_low_src;
            } else {
                high_low_src = "";
            }
            $.each(value.values, function(ind, val) {
                if (val.name == 'High') {
                    if (value.selected && val.selected) {
                        high = true;
                    } else {
                        high = false;
                    }
                }
                if (val.name == 'Low') {
                    if(value.selected && val.selected) {
                        low = true;
                    } else {
                        low = false;
                    }
                }
            });
        }
    });
}

function PeriodChanges(appenAtBegin) {
    var defaultData = $.grep(window.MEData.column_dimensions, function (n) {
        return (n.name.toLowerCase() == "periods");
    });
    var periodPanels = $.grep(window.MEData.panels, function (n) {
            return (n.name.toLowerCase() == "periods");
        })[0];
    if (defaultData.length > 0) {
        var startFY, endFY;
        if (periodPanels.multi_period == true) {
            startFY = periodPanels.selected_from, endFY = periodPanels.selected_to;
        }
        else {
            startFY = periodPanels.selected_from, endFY = periodPanels.selected_from;
        }

        defaultData[0].values = [];

        for (var i = getYear(startFY); i <=  getYear(endFY); i++) {

            var periodPanel = $.grep(periodPanels.all_period_expansion_list, function (n) {
                return (n.year == i);
            });

            $.each(periodPanel,function (item, value) {
                var copyVal = jQuery.extend(true, {}, value);
                defaultData[0].values.push(copyVal);
            })
        }
    }
    periodTypeChange(periodPanels.period_type, false);
    PeriodAppend(appenAtBegin);
}

function periodTypeChange(periodType, checkMeta, interim) {
    var defaultData = window.MEData.column_dimensions.filter( function (n) {
        return (n.name.toLowerCase() == "periods");
    })[0];
    var periodPanels = window.MEData.panels.filter( function (n) {
        return (n.name.toLowerCase() == "periods");
    })[0];

    if (!interim) {
        interim = periodPanels.interim_type;
    }

    var removeNodeIndices = [];
    var interimsArray = [];
    if (defaultData !== undefined) {
        var startFY, endFY;
        if (periodPanels.multi_period == true) {
            startFY = periodPanels.selected_from;
            endFY = periodPanels.selected_to;
        }
        else {
            startFY = periodPanels.selected_from;
            endFY = periodPanels.selected_from;
        }

        defaultData.values = [];

        for (var i = getYear(startFY); i <= getYear(endFY); i++) {

            var periodPanel = periodPanels.all_period_expansion_list.filter( function (n) {
                return (n.year == i);
            });

            for(var item=0; item<periodPanel.length; item++){
                var value = periodPanel[item];
                var copyVal = jQuery.extend(true, {}, value);
                var hasObj = defaultData.values.filter(function (n) {
                    return (n.period.toLowerCase() == copyVal.period.toLowerCase());
                });
                if(hasObj.length == 0)
                    defaultData.values.push(copyVal);
            }
        }
    }
    periodPanels.period_type = periodType;
    switch (periodType){
        case 'A': //set only annual
            for(var index=0; index<defaultData.values.length; index++){
                var value = defaultData.values[index];
                var checkPeriod = value.period.match(/^FY/gi);
                if(checkPeriod){
                    value.expansion_lst = [];
                } else {
                    removeNodeIndices.push(index);
                }
            };
            for (var i=removeNodeIndices.length-1;i>=0;i--){
                defaultData.values.splice(removeNodeIndices[i],1);
            }
        break;
        case 'I': //set only interims
            if (periodPanels.multi_period == false) {
                $("#interimtype").val(interim);
                periodPanels.interim_type = interim;
            }
            if(defaultData){
                for(var item=0; item<defaultData.values.length; item++){
                    var value = defaultData.values[item];
                    var checkPeriod = value.period.match(/^FY/gi);
                    if(!checkPeriod){
                        var obj = jQuery.extend(true, {}, value);
                        interimsArray.push(obj);
                    } else {
                        for(var i=0; i<value.expansion_lst.length; i++){
                            var val = value.expansion_lst[i];
                            //create object for interim
                            var currentPeriod = Object.keys(value.expansion_lst[i])[0];
                            var shortYear = currentPeriod.split('-')[1];
                            shortYear = shortYear.slice(shortYear.length-2, shortYear.length);
                            shortYear = currentPeriod.split('-')[0] + shortYear;
                            var currentForecast = value.forecast;
                            if(periodPanels.actual_estimates[currentPeriod] != void 0){
                                currentForecast = periodPanels.actual_estimates[currentPeriod];
                            }
                            var obj = {
                                display_period: currentForecast ? shortYear+'E' : shortYear,
                                expanded: false,
                                expansion_lst: [],
                                forecast: currentForecast,
                                period: currentPeriod,
                                year: value.year
                            };
                            if (periodPanels.multi_period || interim == "All" || currentPeriod.match("^" + interim)) {
                                interimsArray.push(obj);
                            }
                        };
                    }
                };
                defaultData.values = interimsArray;
            }
        break;
        case 'AI': //set only default from all periods list
             if(checkMeta) {
                 PeriodAppend(false);
             }
        break;
    }
}

function interimTypeChange(interim) {
    var periodPanels = $.grep(window.MEData.panels, function (n) {
        return (n.name.toLowerCase() == "periods");
    })[0];
    periodPanels.interim_type = interim;
    periodTypeChange(periodPanels.period_type, true, interim);
}

function removeRevisionDimension(showIn){
    //TODO change here for revision
    var revisionDimensionIndex;
    if (showIn == "row"){
        $.each(window.MEData.column_dimensions, function(index, value){
            if (value.name == "Revisions"){
                revisionDimensionIndex = index;
            }
        });
        if(revisionDimensionIndex) {
            window.MEData.column_dimensions.splice(revisionDimensionIndex, 1);
        }
    } else if (showIn == "column"){
        $.each(window.MEData.row_dimensions, function(index, value){
            if (value.name == "Revisions"){
                revisionDimensionIndex = index;
            }
        });
        if(revisionDimensionIndex) {
            window.MEData.row_dimensions.splice(revisionDimensionIndex, 1);
        }
    }
}

function setMEDataOnApply(sectionName) {
    var rightPanels = window.MEData.panels.filter( function (n) {
        return (n.name.toLowerCase() == sectionName.toLowerCase());
    })[0];
    var sectionPanelIndex = -1;
    for(var index=0; index<window.MEData.panels.length; index++){
        var value = window.MEData.panels[index];
         if(value.name.toLowerCase() == sectionName.toLowerCase()){
             sectionPanelIndex = index;
         }
    };
    // window.MEData.panels[sectionPanelIndex] = jQuery.extend(true, {}, rightPanels);

    // check change in columndimensions and rowdimensions
    var coldimensionData = window.MEData.column_dimensions.filter( function (n) {
        return (n.name == sectionName);
    });
    var sectionPanelIndexCol = -1;
    for(var index=0; index<window.MEData.column_dimensions.length; index++){
        var value = window.MEData.column_dimensions[index];
        if (value.name.toLowerCase() == sectionName.toLowerCase()) {
            sectionPanelIndexCol = index;
        }
    };
    if (coldimensionData.length != 0 && sectionPanelIndexCol != -1) {
        window.MEData.column_dimensions[sectionPanelIndexCol] = jQuery.extend(true, {}, coldimensionData[0]);
    } else if (coldimensionData.length != 0 && sectionPanelIndexCol == -1){
        window.MEData.column_dimensions.push(jQuery.extend(true, {}, coldimensionData[0]));
    } else if (coldimensionData.length == 0 && sectionPanelIndexCol != -1){
        window.MEData.column_dimensions.splice(sectionPanelIndexCol, 1);
    }

    var rowdimensionData = window.MEData.row_dimensions.filter( function (n) {
        return (n.name == sectionName);
    });
    var sectionPanelIndexRow = -1;
    for(var index=0; index<window.MEData.row_dimensions.length; index++){
        var value = window.MEData.row_dimensions[index];
        if (value.name.toLowerCase() == sectionName.toLowerCase()) {
            sectionPanelIndexRow = index;
        }
    };
    if (rowdimensionData.length != 0 && sectionPanelIndexRow != -1) {
        window.MEData.row_dimensions[sectionPanelIndexRow] = jQuery.extend(true, {}, rowdimensionData[0]);
    } else if (rowdimensionData.length != 0 && sectionPanelIndexRow == -1){
        window.MEData.row_dimensions.push(jQuery.extend(true, {}, rowdimensionData[0]));
    } else if (rowdimensionData.length == 0 && sectionPanelIndexRow!= -1){
        window.MEData.row_dimensions.splice(sectionPanelIndexRow, 1);
    }
}



function htmlInReloadPanels(checkSection,lowerSectionName, gridMetaData, sectionName, panelOpen) {
    var panels_info = {'action':'Panels'};

    if (cut == "STD") {
        gAdjust = "implied";
    }
    for(var indexpanels=0; indexpanels<window.MEData.panels.length; indexpanels++){
        var valuepanels = window.MEData.panels[indexpanels];
        if (valuepanels.name.toLowerCase() == panelSections['periods'].secName.toLowerCase() &&
            (checkSection || (!checkSection && lowerSectionName == panelSections['periods'].secName.toLowerCase()))) {
			panels_info['period_type'] = valuepanels.period_type;
            var select_from = getPeriodLabel(valuepanels.selected_from);
            var select_to = getPeriodLabel(valuepanels.selected_to);
            panels_info['period_selected_from'] = select_from;
            panels_info['period_selected_to'] = select_to;

            FillYearMapping(valuepanels.values);
            periodTypeChange(valuepanels.period_type, false);

            if (calendarYears) {
                window.fiscalEnd = '';
            }
        }
        else if(valuepanels.name.toLowerCase() == panelSections['GrowthTypes'].secName.toLowerCase() && (checkSection || (!checkSection && lowerSectionName == panelSections['GrowthTypes'].secName.toLowerCase()))) {

            gGrowthTypeValues = valuepanels['default'];
            if(!valuepanels.trendYear){
                var periodPanel = window.MEData.panels.filter( function (n) {
                    return (n.name.toLowerCase() == "periods");
                })[0];
                valuepanels.trendYear = periodPanel.selected_from;
            }
            Last_Used_Trend_Year = valuepanels.trendYear;
            panels_info['growth_type_trend_year'] = valuepanels.trendYear;
            panels_info['growth_type_value'] = valuepanels.values;
            RepresentGrowthType();

        }
        else if (valuepanels.name.toLowerCase() == panelSections['Sources'].secName.toLowerCase() && (checkSection || (!checkSection && lowerSectionName == panelSections['Sources'].secName.toLowerCase()))) {

            panels_info['source_type'] = valuepanels.type;
			panels_info['source_default'] = valuepanels.default;
			panels_info['source_default_future'] = valuepanels.default_future;
			panels_info['source_type'] = valuepanels.type;
			panels_info['composite_sources'] = valuepanels.composite;
			panels_info['consensus_sources'] = valuepanels.consensus;
            if (valuepanels['default-future'] && gSourceFuture == '') {
                gSourceFocus = window.gSource = gSourceFuture = valuepanels['default-future'];
            } else if(gSourceFuture == ''){
                window.gSource = gSourceFuture = 'Consensus';
            }
            if(gSourceActual == ''){
                gSourceActual = valuepanels.type != 'row' ? valuepanels['actual-default'] : gSourceFuture;
            }

            sourcesExist = true;

            for(var indexsource=0; indexsource<valuepanels.values.length; indexsource++){
                var valueSource = valuepanels.values[indexsource];
                if(valueSource.values && valueSource.values.length > 0) {
                } else {
                    valueSource.values = [];
                }
            };

            for(var indexsource=0; indexsource<valuepanels.values.length; indexsource++){
                var valueSource = valuepanels.values[indexsource];
                if (valueSource.name.toLowerCase() == "brokers") {
                    if (valuepanels.type == "filter" || cut == 'SAR') {
                        var boxtype = "radio";
                        $("#allentitle").hide();
                        $("#sourcesection").closest('div').hide();
                        $("#sbroker").css('height', '25px').html("<span style='background:#f2f2f2; padding:3px; width:200px;display:block'>Brokers</span>");
                    }
                    else {
                        var boxtype = "checkbox";
                    }
                    for(var indexBroker=0; indexBroker<valueSource.values.length; indexBroker++){
                        var valueBroker = valueSource.values[indexBroker];
                        if (valueBroker.selected && boxtype == "radio") {
                            window.gSource = valueBroker.name;
                        }
                        if (boxtype != "radio") {
                            if (valueBroker.focus){
                                gFocusSource = window.gSource = gSourceFuture = valueBroker.name;
                                if(valuepanels.type == 'row')
                                    gSourceActual = gSourceFuture;
                            }

                        }
                    };
                }
                else if (valueSource.name.toLowerCase() == "computed") {
                    for(var i=0; i<valueSource.values.length; i++){
                        var valueBroker = valueSource.values[i];
                        if (valueBroker.focus){
                            gFocusSource = window.gSource = gSourceFuture = valueBroker.name;
                            if(valuepanels.type == 'row')
                                gSourceActual = gSourceFuture;
                        }
                        if(valueBroker.name == 'Custom'){
                            ccFlag = valueBroker.selected;
                        }

                    };
                }

            };
            sourceCheck();
            custconCheck();
        }
        else if (valuepanels.name.toLowerCase() == "display settings"){
            panels_info['display_settings_type'] = valuepanels.name;
			panels_info['display_settings_default'] = valuepanels.name;
			panels_info['display_settings_selected'] = valuepanels.name;
        }
        else if (valuepanels.name.toLowerCase() == panelSections['Accounting basis'].secName.toLowerCase() ) {
			panels_info['accounting_basis_type'] = valuepanels.type;
			panels_info['accounting_basis_default'] = valuepanels.default;
			panels_info['accounting_basis_selected'] = window.gBasis;
        }
        else if (valuepanels.name.toLowerCase() == panelSections['Adjustments'].secName.toLowerCase()) {

			panels_info['adjustments_type'] = valuepanels.type;
			panels_info['adjustments_default'] = valuepanels.default;
			panels_info['adjustments_selected'] = window.gAdjust;
        }
        else if (valuepanels.name.toLowerCase() == panelSections['Revisions'].secName.toLowerCase()) {
            window.gRevision = valuepanels['default'];
        }

    };

    //heap_tracking(company, panels_info);
    
    //same thing we are doing from where this funtion is getting called

	//deep copy gridMetaData.panels to window.rightPanelChanges
    // gridMetaData.panels = jQuery.extend(true, [], window.rightPanelChanges.panels);
    // gridMetaData.column_dimensions = jQuery.extend(true, [], window.rightPanelChanges.column_dimensions);
    // gridMetaData.row_dimensions = jQuery.extend(true, [], window.rightPanelChanges.row_dimensions);

    // gridMetaData.panels = jQuery.extend(true, [], window.MEData.panels);
    // gridMetaData.column_dimensions = jQuery.extend(true, [], window.MEData.column_dimensions);
    // gridMetaData.row_dimensions = jQuery.extend(true, [], window.MEData.row_dimensions);

}


function visualizationsEvents(valuepanels) {
    // All the display none and block logic is used because in cases of STD as of now we are not displaying all
    // visualisations.
    $('#all-visualisations > div').css('display', 'none')
    var variationSliderValue = -1, revisionSliderValue = -1, selectedRevision = '-6Month', surpriseSliderValue = 5;
    $.each(valuepanels.values, function(index, value){
        if (value.name == 'Show Variation') {
            $('#variation-div').css('display', 'block');
            variationSliderValue = value.slider > 0 ? (value.slider * -1): value.slider;
            if (value.selected) {
                cva = value.name;
            } else {
                cva = "";
            }
        } else if (value.name == 'Revisions') {
            $('#revision-div').css('display', 'block');
            revisionSliderValue = value.slider > 0 ? (value.slider * -1): value.slider;
            selectedRevision = value.value;
            if (value.selected) {
                crdrevision = value.value;
            } else {
                crdrevision = "";
            }
        }else if (value.name == 'Surprise') {
            $('#suprise-div').css('display', 'block');
            surpriseSliderValue = value.slider;
            if (value.selected) {
                surprise = value.name;
            } else {
                surprise = "";
            }
        }else if (value.name == 'High / Low') {
            $('#highlow-div').css('display', 'block');
            if (value.high_low_src == 'all') {
                $('#all_src').attr('checked', true);
                $('#lbl_all_src').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
                $('#lbl_entitled_src').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
            } else {
                $('#entitled_src').attr('checked', true);
                $('#lbl_entitled_src').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
                $('#lbl_all_src').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
            }
            if (value.selected){
                high_low_src = value.high_low_src;
            } else {
                high_low_src = "";
            }
            $.each(value.values, function(ind, val) {
                $('#' + val.name.toLowerCase()).attr('checked', val.selected);
                if (val.name == 'High') {
                    if (value.selected && val.selected) {
                        high = true;
                        $('td[max]').addClass('high');
                    } else {
                        high = false;
                        $('td[max]').removeClass('high');
                    }
                }
                if (val.name == 'Low') {
                    if(value.selected && val.selected) {
                        low = true;
                        $('td[min]').addClass('low');
                    } else {
                        low = false;
                        $('td[min]').removeClass('low');
                    }
                }
                if (val.selected) {
                    $('#lbl_' + val.name.toLowerCase()).removeClass('fa-square-o').addClass('fa-check-square');
                } else {
                    $('#lbl_' + val.name.toLowerCase()).removeClass('fa-check-square').addClass('fa-square-o');
                }
            });
        }
    });
    $('#visual-cancelApply').css('display','block');
    var variationSlider = $( "#variationSlider" ).slider({
        max: -1,
        min: -9,
        animate: "slow",
        step: 2,
        value: variationSliderValue,
        slide: function( event, ui ) {
            $(".dummyForSliderVariation").trigger("variationSliderMoved", ui.value);
        },
        change: function() {
            if(isClearAll === false && cut === 'STD') {
                saveRightPanelSettings('Analysis');
            }
            saveSliderValueInGridMEdata('Show Variation');
        }
    });

    var revisionsPanel;
    for(var revidx=0; revidx < window.MEData.panels.length; revidx++){
        var revPanel = window.MEData.panels[revidx];
        if (revPanel.name.toLowerCase() == "revisions") {
            valuepanels = revPanel;
        }else if(revPanel.name.toLowerCase() == "analysis"){
            revisionsPanel = revPanel.values.filter(function(val){
                return val.name.toLowerCase() == 'revisions'
            })[0];
        }
    }
    
    boxtype = 'radio';
    if (revisionsPanel != undefined) {
        // selected revisions radio button here
        $("#analysis_" + revisionsPanel.selected).attr('checked','checked');
    }

    var revisionSlider = $( "#revisionSlider" ).slider({
        max: -1,
        min: -9,
        animate: "slow",
        step: 2,
        value: revisionSliderValue,
        slide: function( event, ui ) {
            $(".dummyForSliderRevision").trigger("revisionSliderMoved", ui.value);
        },
        change: function() {
            if(isClearAll === false && cut === 'STD') {
                saveRightPanelSettings('Analysis');
            }
            saveSliderValueInGridMEdata('Revisions');
        }
    });

    var surpriseSlider = $( "#surpriseSlider" ).slider({
        max: 5,
        min: 1,
        animate: "slow",
        step: 1,
        value: surpriseSliderValue,
        change: function( event, ui ) {
            if(isClearAll === false && cut === 'STD') {
                saveRightPanelSettings('Analysis');
            }
            $(".surprise-text-color").trigger("surpriseSliderMoved", ui.value);
            saveSliderValueInGridMEdata('Surprise');
        }
    });
    // only add events if they haven't been added earlier.
    //if(!$._data( $(".analysis_sections")[0], "events" ) || !$._data( $(".analysis_sections")[0], "events" ).click) {
        $('#variationSlider-minus').click(function() {
            if(variationSlider.slider('value') > -9) {
                variationSlider.slider('value', variationSlider.slider('value') - variationSlider.slider( "option", "step" ) );
                $(".dummyForSliderVariation").trigger("variationSliderMoved", variationSlider.slider('value'));
            }
        });
        $('#variationSlider-plus').click(function() {
            if(variationSlider.slider('value') < -1) {
                variationSlider.slider('value', variationSlider.slider('value') + variationSlider.slider( "option", "step" ) );
                $(".dummyForSliderVariation").trigger("variationSliderMoved", variationSlider.slider('value'));
            }
        });

        $('#revisionSlider-minus').click(function() {
            if(revisionSlider.slider('value') > -9) {
                revisionSlider.slider('value', revisionSlider.slider('value') - revisionSlider.slider( "option", "step" ) );
                $(".dummyForSliderRevision").trigger("revisionSliderMoved", revisionSlider.slider('value'));
            }
        });
        $('#revisionSlider-plus').click(function() {
            if(revisionSlider.slider('value') < -1) {
                revisionSlider.slider('value', revisionSlider.slider('value') + revisionSlider.slider( "option", "step" ) );
                $(".dummyForSliderRevision").trigger("revisionSliderMoved", revisionSlider.slider('value'));
            }
        });

        $('#surpriseSlider-minus').click(function() {
            if(surpriseSlider.slider('value') > 1) {
                surpriseSlider.slider('value', surpriseSlider.slider('value') - surpriseSlider.slider( "option", "step" ) );
            }
        });
        $('#surpriseSlider-plus').click(function() {
            if(surpriseSlider.slider('value') < 9) {
                surpriseSlider.slider('value', surpriseSlider.slider('value') + surpriseSlider.slider( "option", "step" ) );
            }
        });

        $(".analysis_sections").off('click').on("click", function(evt){
            var toDisable = false;
            var currentElement = $(this);
            if(currentElement.next().is(":visible") || currentElement.hasClass('analysis_sections_selected')) {
                // if sub section is already visible then hide it and show apply button to remove that analysis
                currentElement.next().hide(300);
                currentElement.removeClass('analysis_sections_selected');
                currentElement.trigger("analysis_hideOthers", null);
                toDisable = true;
            }
            else {
                currentElement.next().show(300);
                currentElement.addClass('analysis_sections_selected');
                currentElement.trigger("analysis_hideOthers", $(this).next());
            }
            if(evt.target.id == 'variation'){
                onVariation(toDisable);
            }
            if(evt.target.id == 'revisiondev'){
                onAnalysis($("#analysis_" + selectedRevision)[0], toDisable);
            }
            if(evt.target.id == 'high-low'){
                onHighLow(toDisable);
            }
            if(evt.target.id == 'surprise'){
                onSurprise(toDisable);
            }
            analyticsProcessor(evt);
            evt.stopPropagation();
        });

        $(".analysis_sections").off('analysis_hideOthers').on("analysis_hideOthers",  function(event, visibleSection) {
            // logic here to hide any section which is open other than visiblesection.
            $(".analysis_sections").each(function(idx, obj){
               if(visibleSection == null || $(obj).next()[0].id != visibleSection.id) {
                   $(obj).next().hide(300);
                   $(obj).removeClass('analysis_sections_selected');
               }
            });
        });
    //}
    if (!cva) {
        if ($('#variation').hasClass('analysis_sections_selected')) {
            $('#variation').trigger('click');
        }
    }
    if (!crdrevision) {
        if ($('#revisiondev').hasClass('analysis_sections_selected')) {
            $('#revisiondev').trigger('click');
        }
    }
    if (high_low_src == "") {
        if ($('#high-low').hasClass('analysis_sections_selected')) {
            $('#high-low').trigger('click');
        }
    }
    if (!surprise) {
        if ($('#surprise').hasClass('analysis_sections_selected')) {
            $('#surprise').trigger('click');
        }
    }
    if (cva) {
        if (!$('#variation').hasClass('analysis_sections_selected')) {
            $('#variation').trigger('click');
        }
    } else if (crdrevision) {
        if (!$('#revisiondev').hasClass('analysis_sections_selected')) {
            $('#revisiondev').trigger('click');
        }
    } else if (high_low_src != "") {
        if (!$('#high-low').hasClass('analysis_sections_selected')) {
            $('#high-low').trigger('click');
        }
    } else if (surprise) {
        if (!$('#surprise').hasClass('analysis_sections_selected')) {
            $('#surprise').trigger('click');
        }
    }
}
function adjustChange(adjustID) {
    if ($(adjustID).attr("checked")) {
        gAdjust = 'implied'
    } else {
        gAdjust = 'default'
    }

    if (cut == "STD") {
        gAdjust = 'implied'
    }

    if (cut == 'SAR' && $(adjustID).attr("checked")) {
        gAdjust = adjustID.id;
    }

    var objME = new ModelExplorer();
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Adjustments");
    });
    defaultData[0].values = [window.gAdjust];
    defaultData[0].selected = window.gAdjust;
    objME.LoadDataGrid(window.MEData, false);

    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout(reziseGridPanel, 100);
    analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS.ADJUST.CHANGE, window.gAdjust);
}